define([
    "helpers/apiHelper",
    "services/requests"
], function (apiHelper, requests) {
    "use strict";

    var exports = {
        delMaterialRequisition: function (requisitionId) {
            return requests.remove(apiHelper.getBaseUrl() + "/materialrequisitions/" + requisitionId);
        },

        delMaterialRequisitionItem: function (requisitionId, lineNo) {
            return requests.remove(apiHelper.getBaseUrl() + "/materialrequisitions/" + requisitionId + "/" + lineNo);
        },

        getMaterialRequisition: function (requisitionId) {
            return requests.getJson(apiHelper.getBaseUrl() + "/materialrequisitions/" + requisitionId);
        },

        getMaterialRequisitionItem: function (requisitionId, lineNo) {
            return requests.getJson(apiHelper.getBaseUrl() + "/materialrequisitions/" + requisitionId + "/" + lineNo);
        },

        getMaterialRequisitionsForService: function (dispatchId, fromHistory) {
            if (typeof fromHistory === 'undefined' || fromHistory === null) {
                return requests.getJson(apiHelper.getBaseUrl() + "/dispatch/" + dispatchId + "/materialrequisitions");
            }
            return requests.getJson(apiHelper.getBaseUrl() + "/dispatch/" + dispatchId + "/materialrequisitions" + "?fromHistory=" + fromHistory);
        },

        getMaterialRequisitionsForProject: function (dispatchProjectCode) {
            return requests
                .getJson(apiHelper.getBaseUrl() + "/dispatch/projects/" + dispatchProjectCode + "/materialrequisitions");
        },

        setMaterialRequisitionHeaderForService: function (dispatchId, requisition) {
            return requests.post(apiHelper.getBaseUrl() + "/dispatch/" + dispatchId + "/materialrequisitions", requisition);
        },

        setMaterialRequisitionHeaderForProject: function (dispatchProjectCode, requisition) {
            return requests.post(apiHelper.getBaseUrl() + "/dispatch/projects/" + dispatchProjectCode + "/materialrequisitions",
                requisition);
        },

        setMaterialRequisitionItemForProject: function (dispatchProjectCode, requisitionId, lineNo, item) {
            return requests.post(apiHelper.getBaseUrl() + "/dispatch/projects/" + dispatchProjectCode + "/materialrequisitions/" + requisitionId + "/" + lineNo, item);
        },

        setMaterialRequisitionItemForService: function (dispatchId, requisitionId, lineNo, item) {
            return requests.post(apiHelper.getBaseUrl() + "/dispatch/" + dispatchId + "/materialrequisitions/" + requisitionId + "/" + lineNo, item);
        },

        getMaterialRequisitionsForFieldService: function (workOrderId) {
            return requests.getJson(apiHelper.getWorkOrderBaseUrl(workOrderId) + "/materialrequisitions");
        },

        setMaterialRequisitionHeaderForFieldService: function (workOrderId, requisition) {
            return requests.post(apiHelper.getFieldServiceWorkOrderBaseUrl(workOrderId) + "/materialrequisitions", requisition);
        },

        setMaterialRequisitionItemForFieldService: function (workOrderId, requisitionId, lineNo, item) {
            return requests.post(apiHelper.getFieldServiceWorkOrderBaseUrl(workOrderId) + "/materialrequisitions/" + requisitionId + "/" + lineNo, item);
        }
    };

    return exports;
});
